






























import { InstrumentStatus, SelectedInstrument } from "@/shared/types";
import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import InstrumentName from "@/shared/components/investments/drivewealth/InstrumentName.vue";
import { useDrivewealthSweepStore } from "@/shared/store/drivewealthSweep";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

export interface InstrumentSearchResult {
  instrument: { symbol: string, companyName: string, website: string, imageUrl: string };
  status: string;
  action: SelectedInstrument;
}

@Component({
  components: {
    GenericLoadingSpinner,
    InstrumentName,
  }
})
export default class InstrumentSearchResultsTable extends Vue {
  @Prop({ required: true })
  detailItems: InstrumentSearchResult[];

  @Prop({ required: true })
  showBusyState: boolean;
  drivewealthStore = useDrivewealthStore();
  drivewealthSweepStore = useDrivewealthSweepStore();

  isDisabled (instrumentDetail: SelectedInstrument): boolean {
    return !this.drivewealthSweepStore.isActive
        || this.drivewealthSweepStore.isAlreadySelected(instrumentDetail.stockSymbol)
        || instrumentDetail.status !== InstrumentStatus.Active;
  }

  detailFields = [
    {
      key: "instrument",
      thClass: "text-left pl-2 col-md-6 col-6",
      tdClass: "pl-2 col-md-6 col-6",
      label: "Investment"
    },
    {
      key: "status",
      label: "Status",
      thClass: "text-center col-md-3 d-md-table-cell d-none",
      tdClass: "text-center col-md-3 d-md-table-cell d-none"
    },
    {
      key: "action",
      label: "",
      thClass: "text-center col-md-3 col-6",
      tdClass: "col-md-3 col-6"
    },
  ];
}
